import getBorderRadius from './get-border-radius';

export default {
  getBorderRadius,
};
